exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".style[data-v-3022f81c]{border-bottom:1px solid rgba(0,0,0,.1)}.actions-padding[data-v-3022f81c]{padding-right:18px;padding-bottom:19px;padding-left:18px}.pt-switch[data-v-3022f81c]{padding-top:20px}.modal-size[data-v-3022f81c]{width:auto;height:900px}", "", {"version":3,"sources":["/vercel/path0/src/pages/Company.vue"],"names":[],"mappings":"AACA,wBACE,sCAA2C,CAC5C,AACD,kCACE,mBAAoB,AACpB,oBAAqB,AACrB,iBAAmB,CACpB,AACD,4BACE,gBAAkB,CACnB,AACD,6BACE,WAAY,AACZ,YAAc,CACf","file":"Company.vue","sourcesContent":["\n.style[data-v-3022f81c] {\n  border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n.actions-padding[data-v-3022f81c] {\n  padding-right: 18px;\n  padding-bottom: 19px;\n  padding-left: 18px;\n}\n.pt-switch[data-v-3022f81c] {\n  padding-top: 20px;\n}\n.modal-size[data-v-3022f81c] {\n  width: auto;\n  height: 900px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3022f81c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Company.vue
// module id = 480
// module chunks = 7